import React from "react";
import Layout from "../layout/Layout";
import { Route, Routes } from "react-router";
import { Navigate } from "react-router-dom";
import { routes } from "../routes/routes";
import NotFound from "./not-found/NotFound";
import Login from "./auth/Login";
import Cookies from "js-cookie";
import PDFViewer from "../components/common/pdf-viewer/PDFViewer";
import LoanAllInfo from "./loan/LoanAllInfo";

const PrivateRoute = ({ component }) => {
  const isAuthenticated = Cookies.get("liResponse");
  return isAuthenticated ? component : <Navigate to="/login" />;
};

const ToseeAdmin = () => {
  return (
    <Routes>
      <Route path="/pdf-viewer" element={<PDFViewer />} />
      <Route path="/loan-all-info/:id" element={<LoanAllInfo />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<NotFound />} />
      <Route exact path="/" element={<Layout />}>
        {routes?.map((item) => {
          return (
            <Route
              key={item.path}
              path={item.path}
              element={<PrivateRoute component={item.component} />}
            />
          );
        })}
      </Route>
    </Routes>
  );
};

export default ToseeAdmin;
